import { typographyRem } from '@by-miles/bymiles-styles'
import React from 'react'
const { h4: H4 } = typographyRem

export const SectionTitle = ({ title }) => {
  return <H4 className="component-heading LoNotSensitive">{title}</H4>
}
